import Home from '../components/Home'

const HomePage = () => <Home />

export default HomePage
